import { Component, Input, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IpexFileService } from '../../services/ipex-file.service';
import { CommonService } from '../../services/common.service';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';

@Component({
    selector: 'app-image-loader',
    templateUrl: './image-loader.component.html',
    styleUrls: ['./image-loader.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageLoaderComponent implements OnInit, OnDestroy {
    @Input() fileId: any;
    @Input() resourceData: any;
    @Input() className: string;
    @Input() notFoundMessage: string;
    @Input() notFoundHide: boolean;
    @Input() onErrorUrl: string;

    defaultImageUrl = 'https://az-cdn.selise.biz/selisecdn/cdn/arc2/placeholder-image.png';
    imageUrl: string;
    loading = false;
    imageLoading = true;
    imgTimeOut: any;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private readonly ipexFileService: IpexFileService, private readonly commonService: CommonService) {
        this.notFoundHide = false;
    }

    ngOnInit(): void {
        this.getImage();
        // this.fileService.conversionPipelineSubject.pipe(takeUntil(this.destroy$)).subscribe(resNotification => {
        //     if (resNotification && resNotification.parent) {
        //         if (this.resourceData && resNotification.parent.Id === this.resourceData.EntityItemId) {
        //             this.getImage();
        //         }
        //     }
        // });

        if (this.fileId) {
            this.getImageById(this.fileId);
        } else {
            this.loading = false;
            this.imageLoading = false;
        }
    }

    getImage() {
        this.loading = true;
        this.imageUrl = this.defaultImageUrl;
        if (!this.notFoundMessage) {
            this.notFoundMessage = 'Image not found';
        }

        if (
            this.resourceData &&
            this.resourceData.EntityName !== '' &&
            this.resourceData.EntityItemId !== '' &&
            this.resourceData.FileEntityConnectionTag !== ''
        ) {
            this.ipexFileService
                .getFileUrlById(this.resourceData.EntityItemId, null, SCConfig.ImageSize.THUMBNAIL)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: response => {
                        this.imageUrl = response;
                        this.imageLoading = false;
                        this.loading = false;
                    },
                    error: err => {
                        console.error('Failed to get image', err);
                        this.loading = false;
                        this.imageLoading = false;
                    }
                });
        } else {
            this.loading = false;
        }
    }

    getImageById(fileId: string) {
        this.ipexFileService
            .getFileUrlById(fileId, null, SCConfig.ImageSize.THUMBNAIL)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: res => {
                    this.imageUrl = res;
                    this.imageLoading = true;
                    this.loading = false;
                },
                error: err => {
                    console.error('Failed to get file url', err);
                    this.commonService.showSnackbar('SOMETHING_WENT_WRONG');
                    this.loading = false;
                    this.imageLoading = false;
                }
            });
    }

    onImageLoad() {
        this.imageLoading = false;
    }

    ngOnDestroy(): void {
        clearTimeout(this.imgTimeOut);
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
